import angular from 'angular';

import config from '../../config';

export default function Pages(
  Authentication,
  Restangular,
  PersonaCollection,
  NewsfeedCollection,
  Utils,
  orderByFilter
) {
  'ngInject';

  function _getPageMembers(page) {
    if (page.personas) {
      Restangular.restangularizeCollection(null, page.personas, 'personas');

      if (!page.open) {
        page.personas = page.personas.filter((p) => p.type !== 'everyone');
      }

      page.members = PersonaCollection.unwrapUsers(page.personas);
      if (page.owner && !page.members.find((m) => m.id === page.owner.id)) {
        const owner = PersonaCollection.personasDict[page.owner.id];
        if (owner) {
          page.members.push(PersonaCollection.personasDict[page.owner.id]);
        }
      }
    } else {
      page.personas = [];
      page.members = [];
    }

    if (page.open) {
      page.members = PersonaCollection.unwrapUsers(PersonaCollection.everyones);
    }
  }

  Restangular.extendModel('channels', (page) => {
    if (!page.articles) {
      page.articles = [];
    }

    if (page.articles.length) {
      const order = page.id === 0 ? '-posted' : ['-sticky', '-posted'];
      page.articles = orderByFilter(page.articles, order);
    }

    if (!page.articleBuffer) {
      page.articleBuffer = [];
    }

    if (page.owner) {
      let owner = PersonaCollection.personasDict[String(page.owner.id)];
      if (!owner) {
        owner = Restangular.restangularizeElement(null, page.owner, 'users');
      }

      Utils.extendWithProps(owner, page.owner, ['id', 'fullname', 'isMe']);
    }

    if (typeof page.lastPostDate === 'string') {
      page.lastPostDate = new Date(page.lastPostDate);
    }

    _getPageMembers(page);

    if (page.subscribers) {
      Restangular.restangularizeCollection(null, page.subscribers, 'personas');
    } else {
      page.subscribers = [];
    }

    Restangular.restangularizeCollection(page, page.articles, 'articles');
    page.subscribers = page.subscribers.filter((u) => u.active);

    page.subscribe = subscribe;
    page.unsubscribe = unsubscribe;
    page.addArticle = addArticle;
    page.markAsSeen = markAsSeen;
    page.markAsRead = markAsRead;

    function subscribe() {
      page.subscribed = true;
      NewsfeedCollection.editChannel(page);

      const promise = page.all('subscribers').post();
      promise.catch(() => {
        page.subscribed = false;
        NewsfeedCollection.editChannel(page);
      });

      return promise;
    }

    function unsubscribe() {
      page.subscribed = false;
      const promise = page.all('subscribers').remove();
      promise.catch(() => {
        page.subscribed = true;
        NewsfeedCollection.editChannel(page);
      });

      return promise;
    }

    // Post a new article to a page
    function addArticle(newPost, form) {
      const savedPost = angular.copy(newPost);
      angular.copy({}, newPost);

      if (form) {
        form.$setPristine();
        form.$setUntouched();
      }

      const promise = page.articles.post(savedPost, { 'user-fields': 'id' });

      promise.catch(() => {
        angular.copy(savedPost, newPost);
      });

      return promise;
    }

    function markAsSeen(article) {
      if (config.SKIP_MARK_AS_READ) {
        return;
      }

      if (!article.seen) {
        article.seen = true;
        article.seenby++;
        return Restangular.one('channels', article.channel.id)
          .one('articles', article.id)
          .one('seen')
          .put()
          .catch(() => {
            article.seen = false;
            article.seenby--;
          });
      }
    }

    async function markAsRead() {
      if (config.SKIP_MARK_AS_READ) {
        return;
      }

      await Authentication.sendRequest({
        method: 'put',
        path: `channels/${page.id}/read`,
      });
      page.unreadCount = 0;
    }

    return page;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'channels') {
      if (operation === 'put' || operation === 'post') {
        delete element.articles;
        delete element.subscribers;
        delete element.members;
      }

      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }
    }

    return element;
  });

  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'channels') {
      if (operation === 'post') {
        NewsfeedCollection.addChannel(data);
      }

      if (operation === 'put') {
        NewsfeedCollection.editChannel(data);
      }

      if (operation === 'remove') {
        NewsfeedCollection.deleteChannel(data);
      }
    }

    return data;
  });

  return Restangular.service('channels');
}
